import React from 'react';
import ChangePasswordFunctional from './components/change-password-functional';
import './change-password.scss';

const ChangePassword = () => {
	return <ChangePasswordFunctional />;
};
export default ChangePassword;
